import { HTMLAttributes, useEffect, useState } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

type BrokerHelpGrowBusinessViewProps = HTMLAttributes<HTMLDivElement> & {
  info: {
    helpGrowTitle: string;
    helpGrowInfoList: Array<{ title: string; desc: string; imageUrl: string }>;
  };
};

const BrokerHelpGrowBusinessView = (props: BrokerHelpGrowBusinessViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();
  return (
    <Box className={clsx('flex flex-col items-center', className)}>
      <Box className={clsx('flex flex-col items-center', isMobileLayout ? 'w-full space-y-2' : 'w-[960px] space-y-12')}>
        <Typography variant="h4" className="text-primary-black px-10 text-center font-black">
          {info?.helpGrowTitle}
        </Typography>
        <Box className={clsx('flex justify-center gap-6', isMobileLayout ? 'flex-col' : 'flex-row flex-wrap')}>
          {(info?.helpGrowInfoList || []).map((item, index) => {
            return (
              <Box key={index} className="box-border flex flex-col space-y-3" style={{ flex: `0 0 calc(33.333% - 48px/3)` }}>
                <img width="100%" height="auto" src={item.imageUrl} alt="introduction" />
                <Typography variant="h5" className={clsx('text-primary-black text-center font-black', isMobileLayout ? '' : 'h-[50px]')}>
                  {item.title}
                </Typography>
                <Typography variant="subtitle1" className="text-primary-black text-center text-xl font-medium">
                  {item.desc}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default BrokerHelpGrowBusinessView;
